import React, { useCallback } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { CommonVovClient, DownloadImageRequest } from '../../ApiOld/Api/ApiServerVov';
import { useMobileApi } from '../../Api/Mobile/useMobileApi';
import saveBlob from './Files/SaveBlob';
import getFilenameFromUrl from './Files/GetFileNameFromUrl';

interface ImageDialogProps {
    open: boolean;
    onClose: () => void;
    imageUrl: string | null;
}

export const ImageDialog: React.FC<ImageDialogProps> = ({ open, onClose, imageUrl }) => {
    const { t } = useTranslation();
    const { authorizedMobileEmployeeApi } = useMobileApi(CommonVovClient);
    const [loading, setLoading] = React.useState(false);

    const handleDownload = useCallback(() => {
        if (!imageUrl) return;
        setLoading(true);
        authorizedMobileEmployeeApi.downloadImage(new DownloadImageRequest({ imageUrl: imageUrl }))
            .then((res) => {
                saveBlob(res.data, res.fileName ?? getFilenameFromUrl(imageUrl));
            }).finally(() => {
                setLoading(false);
            });

    }, [imageUrl, authorizedMobileEmployeeApi]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogContent style={{ textAlign: 'center', position: 'relative' }}>

                <Button disabled={loading} variant='contained' onClick={handleDownload} color="primary" sx={{ position: 'absolute', top: '10px', left: '10px' }}>
                    {!loading && t('Download')}
                    {loading && <CircularProgress />}
                </Button>
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', top: '10px', right: '10px' }} color="primary"
                >
                    <CloseIcon />
                </IconButton>
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt="Full-size preview"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '90vh',
                            objectFit: 'contain', // Ensures the image fits within the dialog
                        }}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};
